import api from './api'

const dashboardService = {
  /**
   * Get dashboard KPIs
   */
  getKPIs() {
    return api.get('/enercare/api/v1/dashboard/')
  },

  /**
   * Get activity feed
   */
  getActivity(limit = 10) {
    return api.get('/enercare/api/v1/dashboard/activity/', {
      params: { limit }
    })
  },

  /**
   * Get dashboard configuration
   */
  getConfig() {
    return api.get('/enercare/api/v1/config/')
  },

  /**
   * Update dashboard configuration
   */
  updateConfig(config) {
    return api.put('/enercare/api/v1/config/', config)
  }
}

export default dashboardService
